<template>
  <v-footer
    id="core-footer"
    absolute
    height="auto"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="primary--text footer-links">{{ link.name }}</a>
      </span>
    </div>
     <small>This site is protected by reCAPTCHA and the Google 
      <a href="https://policies.google.com/privacy">Privacy Policy</a> and
      <a href="https://policies.google.com/terms">Terms of Service</a> apply.
    </small>
    <v-spacer />
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      Red Sky Designs Inc.
    </span>
   
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      // { name: 'Home', Link: '/' },
      // { name: 'About Us', Link: 'https://ompay.io/about' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}

</style>